module.exports = __webpack_public_path__ + "img/755.498a3810.gif";